/**------------- Custom Text constants -------------**/

/*  General  */
export const CUSTOM_TEXT_CLASS_NAME_PREFIX = "custom-";

/*  Style  */
export const CUSTOM_TEXT_DEFAULT_OPACITY =
	"var(--opacity-high)";
